import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/mystic/Reveal";

const FAQ_ITEMS = [
  {
    q: "O e-book é físico ou digital?",
    a: "É um produto digital em PDF.",
  },
  {
    q: "Quantas simpatias estão incluídas?",
    a: "São 50 simpatias, além de orações e bônus especiais.",
  },
  {
    q: "Preciso ter experiência com simpatias?",
    a: "Não. O conteúdo apresenta instruções acessíveis.",
  },
  {
    q: "As simpatias garantem que meu ex vai voltar?",
    a: "Não. São práticas simbólicas e espirituais, sem garantia de reconciliação. O reencontro depende da vontade e das escolhas das pessoas envolvidas.",
  },
  {
    q: "Posso acessar pelo celular?",
    a: "Sim. O arquivo PDF pode ser aberto em dispositivos compatíveis.",
  },
  {
    q: "Como recebo o produto?",
    a: "O acesso será disponibilizado conforme o processo de entrega configurado na Monetizze, após a confirmação do pagamento.",
  },
];

export function Faq() {
  return (
    <section data-testid="faq-section" className="relative bg-carddark">
      <div className="mx-auto max-w-3xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal className="text-center">
          <Eyebrow>Perguntas frequentes</Eyebrow>
          <h2 className="font-serif text-3xl font-semibold text-creme sm:text-4xl">
            TUDO O QUE VOCÊ <span className="gold-text italic">PRECISA SABER</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-dourado/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 text-left font-serif text-lg text-creme transition-colors hover:text-dourado hover:no-underline sm:text-xl"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  className="pb-6 text-base leading-relaxed text-creme/75"
                  data-testid={`faq-answer-${i}`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
